<template>
  <svg width="20" height="20" viewBox="0 0 20 20">
    <path
      d="M10 7.09a2.908 2.908 0 1 0 0 5.82 2.908 2.908 0 1 0 0-5.82zm6.502 2.183a6.541 6.541 0 0 0-5.775-5.775V2H9.273v1.498a6.541 6.541 0 0 0-5.775 5.775H2v1.454h1.498a6.541 6.541 0 0 0 5.775 5.775V18h1.454v-1.498a6.541 6.541 0 0 0 5.775-5.775H18V9.273h-1.498zM10 15.09A5.087 5.087 0 0 1 4.91 10 5.087 5.087 0 0 1 10 4.91 5.087 5.087 0 0 1 15.09 10 5.087 5.087 0 0 1 10 15.09z"
      :fill="color"
      fill-rule="evenodd"
    />
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#1D1D20',
    },
  },
}
</script>
